import { AxiosInstance, AxiosResponse } from "axios";
import AutocompleteApi from "@/common/api/AutocompleteApi";
import { axiosInstance } from "@/plugins/axios";
import { Api } from "@/common/api/Api";
import WorkPeriodRouter from "@/context/work_period/router/WorkPeriodTemplateRouter";
import { AssignWorkPeriod } from "@/context/work_period/model/AssignWorkPeriod";
import { LocationAutocompleteView } from "@/context/location/model/LocationAutocompleteView";

export class WorkPeriodApi extends Api {
  private static _instance: WorkPeriodApi;
  public static instance(): WorkPeriodApi {
    if (!WorkPeriodApi._instance) {
      WorkPeriodApi._instance = new WorkPeriodApi(axiosInstance);
    }
    return WorkPeriodApi._instance;
  }
  private constructor(axios: AxiosInstance) {
    super(WorkPeriodRouter.BASE_PATH, axios);
  }

  public static async delete(id: number): Promise<AxiosResponse> {
    const response: AxiosResponse = await axiosInstance.delete(
      `${WorkPeriodRouter.BASE_PATH}/${id}`
    );
    return response;
  }

  public async assign(cmd: AssignWorkPeriod): Promise<AssignWorkPeriod> {
    const response: AxiosResponse = await axiosInstance.post<AssignWorkPeriod>(
      `${WorkPeriodRouter.BASE_PATH}/assign`,
      cmd
    );
    return response.data;
  }
  public async findAutocomplete(
    search: string,
    query: string
  ): Promise<Array<LocationAutocompleteView>> {
    const response: AxiosResponse = await AutocompleteApi.findAutocomplete("wpt", search, query);
    return response.data;
  }
}
